import { withPrefix } from 'gatsby';
import 'isomorphic-fetch';
import jsCookie from 'js-cookie';
import urljoin from 'url-join';

const csrfCookieName = 'csrftoken';
const csrfCookieOptions = {
  expires: 3,
  path: '/',
};
const csrfTokenLength = 64;
const possibleSigns = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const possibleSignsLength = possibleSigns.length;

function csrfToken() {
  let csrftoken = '';

  for (let i = 0; i < csrfTokenLength; i++) {
    csrftoken += possibleSigns.charAt(Math.floor(Math.random() * possibleSignsLength));
  }

  return csrftoken;
}

function csrfSafeMethod(method) {
  // these HTTP methods do not require CSRF protection
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method); // todo może dać ignore case for regexp?
}

function csrfCreateCookie() {
  const csrftoken = csrfToken();

  jsCookie.set(csrfCookieName, csrftoken, csrfCookieOptions);

  return csrftoken;
}

function getCsrfToken() {
  let csrfCookie = jsCookie.get(csrfCookieName);

  if (!csrfCookie || !csrfCookie.length || csrfCookie.length !== csrfTokenLength) {
    csrfCookie = csrfCreateCookie();
  }

  return csrfCookie;
}

const log = console.log;

const createHeaders = () => {
  return {
    'X-CSRFToken': getCsrfToken(),
  };
};

export default class QuizService {
  static async authStudent({ schoolCode, classNumber }) {
    if (!schoolCode) throw new Error('schoolCode is missing');
    if (!classNumber) throw new Error('classNumber is missing');

    const url = '/_ajax/skoquiz/submit_student/';
    const method = 'POST';
    const headers = createHeaders();
    const body = JSON.stringify({ schoolCode, classNumber });

    try {
      log({ url, method, headers });
      const res = await fetch(url, { method, headers, body });
      log({ res });
      const json = await res.json();
      log({ json });
      return json;
    } catch (error) {
      log({ error });
      throw new Error('Błąd połączenia z serwerem. Spróbuj ponownie później.');
    }
  }

  static async saveAnswers({ id, validAnswers, passed, answers }) {
    if (id === undefined) throw new Error('id is missing');
    if (validAnswers === undefined) throw new Error('validAnswers is missing');
    if (passed === undefined) throw new Error('passed is missing');
    if (!answers) throw new Error('answers is missing');

    const url = `/_ajax/skoquiz/submit_quiz/${id}/`;
    const method = 'POST';
    const headers = createHeaders();
    const body = JSON.stringify({ validAnswers, passed, answers });

    try {
      log({ url, method, headers });
      const res = await fetch(url, { method, headers, body });
      log({ res });
      const json = await res.json();
      log({ json });
      return json;
    } catch (error) {
      log({ error });
      throw error;
    }
  }
}
